function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#d6d6d6",
  stroke: "#d6d6d6",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  rx: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(14 15) rotate(-90)",
  fill: "#d6d6d6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.143,1.429a1,1,0,0,1,1.715,0l4.234,7.056A1,1,0,0,1,10.234,10H1.766A1,1,0,0,1,.909,8.486Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 6.000001907348633 3.887310981750488 L 3.532391548156738 7.999998092651367 L 8.467611312866211 7.999998092651367 L 6.000001907348633 3.887310981750488 M 5.999999523162842 0.9436531066894531 C 6.331644535064697 0.9436531066894531 6.663289546966553 1.105487823486328 6.857489585876465 1.429158210754395 L 11.09129905700684 8.485507965087891 C 11.49121952056885 9.15202808380127 11.01109981536865 9.999998092651367 10.23380947113037 9.999998092651367 L 1.766189575195313 9.999998092651367 C 0.9888992309570313 9.999998092651367 0.5087795257568359 9.15202808380127 0.9086999893188477 8.485507965087891 L 5.142509460449219 1.429158210754395 C 5.336709499359131 1.105487823486328 5.668354511260986 0.9436531066894531 5.999999523162842 0.9436531066894531 Z",
  stroke: "none",
  fill: "#d6d6d6"
}));

var SvgAdmarket = function SvgAdmarket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "adsformat",
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdmarket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Admarket.301e26c6.svg";
export { ForwardRef as ReactComponent };